import { ReactComponent as CloseSvg } from '@trinsly/common/src/assets/icons/close.svg'
import Row from '@trinsly/common/src/components/atoms/row'
import Separator from '@trinsly/common/src/components/atoms/separator'
import Button from '@trinsly/common/src/components/molecules/button'
import React from 'react'
import ThreadType from 'types/thread-type'
import CancelThreadEmailConfirmationModal from './cancel-thread-email-confirmation-modal'

export type CancelThreadEmailButtonProps = {
  email: ThreadType['emails'][number] | undefined
}

function CancelThreadEmailButton({ email }: CancelThreadEmailButtonProps) {
  const [visible, setVisible] = React.useState(false)

  return (
    <React.Fragment>
      <Button
        size="sm"
        intent="danger"
        variant="outline"
        onClick={() => {
          setVisible(true)
        }}
      >
        <Row className="items-center">
          <CloseSvg className="w-4 h-4" />
          <Separator size="xs" />
          Cancel
        </Row>
      </Button>
      <CancelThreadEmailConfirmationModal
        email={email}
        visible={visible}
        onRequestClose={() => setVisible(false)}
      />
    </React.Fragment>
  )
}

export default CancelThreadEmailButton
